export default "__VITE_ASSET__fcb03052__"